module.exports = __webpack_public_path__ + "static/media/gold_buton.29deee39.png";